.modal {
  max-width: 1100px;
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}

.content {
  display: flex;
  gap: 24px;
  overflow: hidden;
  height: calc(100vh - 370px);
  max-height: 650px;
}

.formSection {
  flex: 1 1 65%;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  overflow-y: auto;
  min-height: 0;
  padding: 0 2% 0 8px;
}

.previewSection {
  flex: 0 1 35%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 8px;
  justify-content: center;
  overflow-y: auto;
  min-height: 0;
}

.fieldSection {
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

.fieldTitle {
  margin: 4px 0 2px;
  font-weight: 500;
  font-size: 13px;
}

.fieldTitleRow {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 4px 0 2px;
  font-weight: 500;
  font-size: 13px;
}

.fieldTitleWithAction {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.tooltipIcon {
  cursor: help;
  font-size: 14px;
  @include themify($themes) {
    color: themed("neutral-primary");
  }
}

.inlineRow {
  display: flex;
  gap: 12px;
}

.inlineField {
  flex: 1;
  min-width: 0;
}

.parameterSamples {
  display: flex;
  flex-direction: column;
  row-gap: 6px;
  padding: 12px;
  border-radius: 12px;

  @include themify($themes) {
    background-color: themed("neutral-secondary");
  }
}

.parameterLabel {
  font-size: 12px;
  margin-bottom: 2px;
}

.buttonRow {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
}

.buttonRowFields {
  display: flex;
  flex: 1;
  gap: 6px;
  align-items: flex-start;
}

.buttonTextField {
  width: 100%;
}

.removeButton {
  cursor: pointer;
  @include themify($themes) {
    color: themed("error-primary");
  }
  font-size: 18px;
  padding: 2px 4px;
  flex-shrink: 0;

  &:hover {
    opacity: 0.7;
  }
}

.addButtonLink {
  cursor: pointer;
  @include themify($themes) {
    color: themed("brand-primary");
  }
  font-size: 13px;
  font-weight: 500;
  margin-top: 4px;

  &:hover {
    text-decoration: underline;
  }
}

.maxButtonsText {
  font-size: 12px;
  @include themify($themes) {
    color: themed("neutral-primary");
  }
}

.noButtonsText {
  font-size: 14px;
  @include themify($themes) {
    color: themed("neutral-primary");
  }
}

.headerTypeRow {
  display: flex;
  gap: 8px;
}

.helperText {
  font-size: 11px;
  @include themify($themes) {
    color: themed("neutral-primary");
  }
  margin-top: -10px;
}

.phoneFrame {
  width: 100%;
  max-width: 280px;
  height: min(100%, 520px);
  border: 2px solid #ddd;
  border-radius: 24px;
  overflow: hidden;
  background: #e5ddd5;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}

.phoneHeader {
  background: #075e54;
  color: #fff;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.phoneAvatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #128c7e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.chatArea {
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.chatBubble {
  background: #fff;
  border-radius: 8px;
  max-width: 100%;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  word-wrap: break-word;

  .bubbleContent {
    padding: 8px 12px;
  }

  .mediaHeaderPreview {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 8px;
    margin-bottom: 4px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background: #f0f0f0;
    font-size: 12px;
    @include themify($themes) {
      color: themed("neutral-primary");
    }
    height: 6rem;

    &.hasMediaPreview {
      padding: 0;
    }

    svg {
      width: 32px;
      height: 32px;
    }

    &.hasTextPreview {
      svg {
        width: 24px;
        height: 24px;
      }
    }

    .filePreview {
      display: flex;
      height: 100%;
      width: 100%;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
      }
    }

    .fileDetails {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 13px;
      padding: 0 10px;
      overflow: hidden;

      .fileDetailsText {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .bubbleHeader {
    font-weight: 700;
    font-size: 13px;
    margin-bottom: 4px;
    color: #333;
  }

  .bubbleBody {
    font-size: 13px;
    color: #333;
    white-space: pre-wrap;
    line-height: 1.4;
  }

  .bubbleFooter {
    font-size: 11px;
    color: #999;
    margin-top: 4px;
  }

  .bubbleTime {
    font-size: 11px;
    @include themify($themes) {
      color: themed("neutral-primary");
    }
    margin-top: 4px;
    text-align: right;
  }
}

.previewButtons {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 6px;
}

.previewButton {
  background: #fff;
  border-radius: 6px;
  padding: 6px 12px;
  text-align: center;
  font-size: 12px;
  color: #00a5f4;
  font-weight: 500;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.emptyPreview {
  @include themify($themes) {
    color: themed("neutral-primary");
  }
  font-size: 13px;
  text-align: center;
}

.typeSelect {
  min-width: 175px;
}

.mediaUploadSection {
  margin: 4px 0;
}

.mediaDropzone {
  margin: 15px 0 5px 0 !important;
}

.mediaUploadStatus {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  height: 71px;
  border-radius: 12px;
  margin: 15px 0 5px 0;

  @include themify($themes) {
    background-color: themed("neutral-tertiary");
    border: 1px solid themed("neutral-secondary");
    color: themed("neutral-primary");
  }

  .mediaUploadStatusContent {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
}

.mediaFileName {
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 180px;
}

.uploadingText {
  @include themify($themes) {
    color: themed("neutral-primary");
  }
}

.uploadedText {
  color: #2e7d32;
}

.uploadErrorText {
  color: #d32f2f;
}

.removeMediaBtn {
  cursor: pointer;
  font-size: 24px;
  @include themify($themes) {
    color: themed("neutral-primary");
  }

  &:hover {
    opacity: 0.7;
  }
}

@media (max-width: 768px) {
  .content {
    flex-direction: column;
    overflow-y: auto;
    height: auto;
  }

  .formSection {
    flex: 1 1 auto;
    overflow-y: visible;
  }

  .previewSection {
    display: none;
  }

  .phoneFrame {
    width: 100%;
    max-width: 280px;
  }
}

@media (max-height: 700px) {
  .content {
    height: calc(100vh - 240px);
  }

  .chatArea {
    min-height: 200px;
  }
}
